import { API_VERSIONS } from "../utils/constants";
import RequestHandler from "./RequestHandler";

function LegalSettingsAPI() {
    const baseAPI = "legal-settings";

    async function confirm() {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${baseAPI}/confirm`,
                {}
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        confirm,
    };
}

export default LegalSettingsAPI();
